/**
 * Navigatsiya xaritasi.
 *
 * TUZILISHI BREND KONSEPSIYASIDAN (brandbook 03-sahifa «Konsepsiyaning
 * 3 ustuni»): Tinglaydi → Monitor · Sezadi → Alert · O'stiradi → Coach.
 * Bo'limlar shu uch ustunga bo'lingan, chunki foydalanuvchi mahsulotni
 * aynan shu tarzda tushuntirilgan holda sotib oladi — interfeys va va'da
 * bir xil so'zlarni ishlatishi kerak (NF-602).
 *
 * `roles` — kimga KO'RINADI. Bu himoya emas (haqiqiy tekshiruv API va RLS
 * da), lekin menejerga o'zi ocholmaydigan bo'limni ko'rsatish — xato.
 */

export interface NavItem {
  readonly to: string;
  readonly label: string;
  /** Bo'sh bo'lsa — barcha rollarga. */
  readonly roles?: readonly string[];
  /** Aniq moslik talab qilinadimi (bosh sahifa uchun). */
  readonly exact?: boolean;
  readonly icon: NavIcon;
}

export interface NavGroup {
  /** Brend ustuni nomi — `null` bo'lsa guruh sarlavhasi ko'rsatilmaydi. */
  readonly kicker: string | null;
  readonly items: readonly NavItem[];
}

export type NavIcon =
  | "pulse"
  | "calls"
  | "analytics"
  | "alert"
  | "leads"
  | "team"
  | "report"
  | "assistant"
  | "settings"
  | "profile"
  | "tasks"
  | "my";

export const NAV_GROUPS: readonly NavGroup[] = [
  {
    kicker: null,
    items: [{ to: "/", label: "Biznes pulsi", exact: true, icon: "pulse" }],
  },
  {
    // «Tinglaydi» — har qo'ng'iroq yozib olinadi va tahlil qilinadi.
    kicker: "Monitor",
    items: [
      { to: "/calls", label: "Qo'ng'iroqlar", icon: "calls" },
      // PP-611–618 — chuqur analitika; menejer ko'rmaydi (NF-303).
      { to: "/analytics", label: "Analitika", roles: ["owner", "rop"], icon: "analytics" },
    ],
  },
  {
    // «Sezadi» — xavf va chetlashish signali.
    kicker: "Alert",
    items: [
      { to: "/signals", label: "Signallar", roles: ["owner", "rop"], icon: "alert" },
      // M5 — yo'qotilgan/xavfdagi lidlar (PP-501–505).
      { to: "/leads", label: "Lid xulosalari", roles: ["owner", "rop"], icon: "leads" },
    ],
  },
  {
    // «O'stiradi» — jamoa reytingi va shaxsiy tavsiya.
    kicker: "Coach",
    items: [
      // M10 — AI va kouching vazifalari (PP-1001–1004); barcha rollarga.
      { to: "/tasks", label: "Vazifalar", icon: "tasks" },
      // PP-1005 — menejerning shaxsiy sahifasi.
      { to: "/my", label: "Mening sahifam", roles: ["manager"], icon: "my" },
      { to: "/team", label: "Jamoa", roles: ["owner", "rop"], icon: "team" },
      { to: "/reports", label: "Hisobotlar", roles: ["owner", "rop"], icon: "report" },
      // M7 — AI yordamchi (PP-701–704), RBAC: owner/rop.
      { to: "/assistant", label: "AI yordamchi", roles: ["owner", "rop"], icon: "assistant" },
    ],
  },
  {
    kicker: null,
    items: [
      // Profil BARCHA rollarga: 2FA foydalanuvchining o'z hisobiga tegishli.
      { to: "/profile", label: "Profil", icon: "profile" },
      { to: "/settings", label: "Sozlamalar", roles: ["owner"], icon: "settings" },
    ],
  },
];

/** Rolga ko'rinadigan bo'limlarni qaytaradi. */
export function visibleGroups(role: string): NavGroup[] {
  return NAV_GROUPS.map((group) => ({
    ...group,
    items: group.items.filter((item) => !item.roles || item.roles.includes(role)),
  })).filter((group) => group.items.length > 0);
}
